import utility from "./utility";
import request from "./curl";
import AtTa from "../components/at_custom/AtTextarea";
import attachment_dialog from "../components/attachment_dialog";
import message_format from "../components/message_format";
import board_utility from "./board_utility";
import media_utility from './media_utility';
import SpeechRecognition from "annyang"


export default {
  props: ["replyMsg", "chat_container_width"],
  components: { AtTa, attachment_dialog, message_format },
  data: () => ({
    data: {},
    msg: "",
    snackbar: false,
    err_msg: "",
    style_link_prev: {
      position: "absolute",
      bottom: "68px",
      background: "#fafafa",
    },
    rich_message_data: {},
    is_send_message: false,
    participants: [],
    users: [],
    skip_enter_for_select_mention_user: false,
    // Share attachment variables
    attachmentFileDialog: false,
    attachment_file_src: null,
    attachment_options: false,
    allowedMimeType: "",
    attachment_file: null,
    // End share attachment variables
    VUE_APP_ENV: process.env.VUE_APP_ENV,
    selectedGroupId:"",
    mention_users_for_attachment:[],
    atCommands: [{"command_name":"help", "command_desc":"Get all available commands"}, {"command_name":"todo", "command_desc":"Adds chat to default ToDo board"}, {"command_name":"calendar", "command_desc": "Ex. Meeting at 12pm tomorrow"}, {"command_name":"reminder", "command_desc": "Ex. Review sales pitch at 10am on 01 Mar 2021"}],
    atBoardNTopicList: [],
    at_board_topic_list_for_msg:[],
    onmount_selectedGroup: "",
    batch_size: 100,
    batch_no: 1,
    sendMsgBoxMaxWidthCss: 1200,
    voices: [],
    speechRecognition: null,
    v2sMsg: "",
    microphone_state: 0,
    SHOWMICROPHONE: false
  }),
  computed: {
    userData() {
      return this.$store.getters.userData;
    },
    externalAppSharedText() {
      return this.$store.getters.externalAppSharedText;
    },
    async selectedGroup() {
      return await this.$store.getters.selectedGroup;
    },
    mutableReplyMsg: {
      get: function () {
        return this.replyMsg;
      },
      set: function () {
        return {};
      },
    },
    async getUserContactList() {
      return await this.$store.getters.getUserContactList;
    },
    async getGroupParticipantCountLs () {
      return await this.$store.getters.getGroupParticipantCount;
    },
    async getGroupParticipantsLs () {
      return await this.$store.getters.getGroupParticipants;
    }
  },
  async mounted() {
    this.getMaxWidth();
    this.onmount_selectedGroup = await this.selectedGroup;
    this.get_group_participant_count();
    this.get_board_for_selected_group();
    this.initSpeech2Text();
  },
  async updated() {
    let current_selectedGroup = await this.selectedGroup;
    if(this.onmount_selectedGroup != current_selectedGroup){
      //Get the updated boards on group change
      this.atBoardNTopicList = [];
      this.at_board_topic_list_for_msg = [];
      this.onmount_selectedGroup = current_selectedGroup;
      this.get_board_for_selected_group();
    }

    this.set_rich_message_position();
  },
  methods: {
    /**
     * Init the Speech to text engine
     */
    initSpeech2Text () {
      this.SHOWMICROPHONE = this.userData.user_email.includes("gide.ai") || this.userData.user_email.includes("miniventurelab.com") || this.userData.user_email.includes("highschoolmoms.com") ? true : false
      this.speechRecognition = SpeechRecognition
    },
    /**
     * speech to text
     */
    speechtotext () {
      this.microphone_state = 1
      let context = this
      const commands = {
        "*phrase": async (phrase) => {
          context.msg = phrase
          context.collect_msg()
          context.speechtotextAbort()
        }
      }
      this.speechRecognition.addCommands(commands)

      this.speechRecognition.start({ continuous: false })
    },
    /**
     * Abort speech to text
     */
    speechtotextAbort () {
      this.microphone_state = 0
      this.speechRecognition.abort()
    },  
    /**
     * collect_msg
     */
    collect_msg() {
      let ws = new RegExp(/^\s+$/);
      if (!this.msg || ws.test(this.msg)) {
        this.snackbar = true;
        this.err_msg = "Please write a msg";
      }
      else {
        if (this.skip_enter_for_select_mention_user) {
          return;
        }

        //Mention user
        if (this.users.length > 0) {
          this.msg = this.replaceUserNameMicro(this.msg);
        }

        let msg_obj = {
          msg: this.msg,
        };

        //Board & Topic List
        if (this.at_board_topic_list_for_msg.length > 0) {
          msg_obj["at_board_topic_list"] = this.at_board_topic_list_for_msg
          this.at_board_topic_list_for_msg = [];
        }

        if (Object.keys(this.mutableReplyMsg).length > 0) {
          msg_obj["is_reply"] = true;
          msg_obj["message_id"] = this.mutableReplyMsg["this_message_id"];
        }

        this.$emit("message", msg_obj, this.users, this.attachment_file);
        this.msg = "";
        this.users = [];
        this.rich_message_data = {};
        this.is_send_message = true;
        this.attachment_file = null;
      }
    },
    /**
     * set_rich_message_position: set position of rich message box
     */
    set_rich_message_position() {
      let chat_box_text_area = document.getElementById("chat_box_text_area");
      this.style_link_prev["width"] = chat_box_text_area.clientWidth + "px";
      this.style_link_prev["bottom"] = chat_box_text_area.clientHeight + "px";
      this.style_link_prev["display"] = "block";
    },
    /**
     * Set the max width for the send box to show properly on ipad, tab, laptop
     */
    getMaxWidth() {
      let chat_box_text_area = document.getElementById("chat_box_text_area");

      if(this.sendMsgBoxMaxWidthCss > chat_box_text_area.clientWidth) {                
        this.sendMsgBoxMaxWidthCss = `max-width: 900px;`;
      }
      else{
        this.sendMsgBoxMaxWidthCss = `max-width: 1200px;`;
      }
    },
    /**
     * richMessage
     */
    richMessage(event) {
      this.skip_enter_for_select_mention_user = false;

      if (event.key === "Enter") {
        return;
      }
      //if message sent then empty rich_message_data
      if (this.is_send_message) {
        this.rich_message_data = {};
      }

      this.is_send_message = false;
      //fetch url from text
      let urls = utility.detectUrlFromText(this.msg);
      //check urls is not null
      if (urls) {
        //get first url and check url is valid
        let url = urls[0];
        if (utility.isValidUrl(url)) {
          //get rich message from server
          this.url = url;
          this.getLinkPreview();
        }
        else {
          console.log(this.msg);
        }
      }
      else {
        this.url = "";
        this.rich_message_data = {};
      }
    },
    /**
     * getLinkPreview
     */
    getLinkPreview() {
      var post_data = new FormData();
      post_data.append("chat_user_id", this.userData.user_id);
      post_data.append("url", this.url);

      request
        .curl(this, "link_preview", post_data, process.env.VUE_APP_MESH_DOMAIN)
        .then((response) => {
          if (response.resp_status) {
            if (response.resp_data.title) {
              this.rich_message_data = response.resp_data;
            }
            else {
              this.rich_message_data = {};
            }
          }
        });
    },
    /**
     * close_reply
     */
    close_reply() {
      this.$emit("replyClosed", false);
    },
    /**
     * get_group_participant_count
     * Always get the count of participants in the selected group
     */
    async get_group_participant_count () {
      try {
        let selectedGroupId = await this.selectedGroup;

        let grpParticipantCountList = await this.getGroupParticipantCountLs
        if (grpParticipantCountList && typeof grpParticipantCount == "string") {
          grpParticipantCountList = JSON.parse(grpParticipantCountList)
        }

        var post_data = new FormData();

        post_data.append("chat_user_id", this.userData.user_id);
        post_data.append("group_id", selectedGroupId);
        post_data.append('get_participant_count', true);
        post_data.append("batch_no", this.batch_no);
        post_data.append("batch_size", this.batch_size);

        request.curl(this, "group_participant_list", post_data)
        .then(async (participantListResponse) => {
          if (participantListResponse.resp_status) {
            const countFromAPI = participantListResponse.total_count

            // If LS count mismatch wit server count
            if (!grpParticipantCountList || !grpParticipantCountList[selectedGroupId] || countFromAPI != grpParticipantCountList[selectedGroupId]) {
              // Save the first chunk of group participants in LF

              let grpParticipantLS = await this.getGroupParticipantsLs
              if (!grpParticipantLS) {
                // Loading the participants for the first time
                this.$store.commit("setGroupParticipants", {[selectedGroupId]: participantListResponse.resp_data})
              }
              else {
                // groups exist so update the participant list
                grpParticipantLS[selectedGroupId] = participantListResponse.resp_data
                this.$store.commit("setGroupParticipants", grpParticipantLS)
              }

              // get the subsequent chunks of group participants
              // The below for-loop gets all the participants in chunks and updates the localstorage.
              for (let i=0; i < Math.ceil(countFromAPI / this.batch_size) - 1; i++) {
                this.get_group_participants_api()
              }
            }

            // Get the latest participant list from LS
            let grpParticipantLS_latest = await this.getGroupParticipantsLs;
            this.participants = grpParticipantLS_latest[selectedGroupId]

            // handling missing participant names
            this.participants.forEach(e => {
              if (!e.participant_name) {
                e.participant_name = e.participant_email.split('@')[0]
              }
            })
          }
        })
      }
      catch (err) {
        console.error("Execption in get_group_participant_count and err: ", err)
      }
    },
    /**
     * get group participants api
     */
    async get_group_participants_api() {
      let selectedGroupId = await this.selectedGroup;
      let grpParticipantLS = await this.getGroupParticipantsLs

      if (selectedGroupId) {
        this.batch_no++

        var post_data = new FormData();
        post_data.append("chat_user_id", this.userData.user_id);
        post_data.append("group_id", selectedGroupId);
        post_data.append("batch_no", this.batch_no);
        post_data.append("batch_size", this.batch_size);

        request.curl(this, "group_participant_list", post_data)
        .then(async (participantListResponse) => {
          if (participantListResponse.resp_status) {
            // Merge new participants with old participants
            // let newParticipants = [...grpParticipantLS[selectedGroupId], ...participantListResponse.resp_data];
            grpParticipantLS[selectedGroupId] = [...grpParticipantLS[selectedGroupId], ...participantListResponse.resp_data];
            this.$store.commit("setGroupParticipants", grpParticipantLS)
          }

          // store the count of participants in LF
          let grpParticipantCountList = await this.getGroupParticipantCountLs
          if (grpParticipantCountList && typeof grpParticipantCountList == "string") {
            grpParticipantCountList = JSON.parse(grpParticipantCountList)
          }

          if (!grpParticipantCountList) {
            this.$store.commit("setGroupParticipantCount", {[selectedGroupId]: grpParticipantLS[selectedGroupId].length})
          }
          else {
            grpParticipantCountList[selectedGroupId] = grpParticipantLS[selectedGroupId].length
            this.$store.commit("setGroupParticipantCount", grpParticipantCountList)
          }
        });
      }
    },
    /**
     * at_add_user
     * Called when the user selects a name from the AT list of user
     */
    at_add_user(user) {   
      this.users.push(user);
    },
    /**
     * at_delete_user
     * Called when the user deletes user from AT list. Remove it from final list 
     */
    at_delete_user(user) {
      this.users = this.users.filter((u) => u.user_id != user.participant_id);
    },
   /*
    * get_board_for_selected_group
    *
    */
    async get_board_for_selected_group() {  
      let response = await board_utility.board_and_topic_list(this, await this.selectedGroup);
      if(!response.resp_status){
        return false;
      }

      let board_topic_list = response.resp_data.data;

      for(let board_topic of board_topic_list){
        //Omit blank topic names
        if(board_topic.topic_name == ""){
          continue;
        }
        
        this.atBoardNTopicList.push(board_topic);
      }
    },
    /**
     * at_add_board_topic
     * Called when the user selects board/topic on *boards
     */
    at_add_board_topic(at_board_topic_list) {
      this.at_board_topic_list_for_msg.push(at_board_topic_list);
    },
    /**
     * at_delete_board_topic
     * Called when the user deletes board/topic from *boards AT List. Remove it from final list 
     */
    at_delete_board_topic(at_board_topic_list) {
      this.at_board_topic_list_for_msg = this.at_board_topic_list_for_msg.filter((u) => u.board_id != at_board_topic_list.board_id);
    },    
    /**
     * getAtsInMessage
     */
    getAtsInMessage(msg) {
      var regex = new RegExp("@" + "(.*?)" + " ", "gm");
      var tagStrArr = msg.match(regex);
      return tagStrArr;
    },
    /**
     * replaceUserNameMicro
     */
    replaceUserNameMicro(msg) {
      if (this.users.length > 0) {
        this.users.forEach((user) => {
          if (user) {
            var user_id_tag ="{@userid_" + user.user_id + "_" + user.user_name + "} ";
            var user_tag = "@" + user.user_name;
            msg = msg.replace(user_tag, user_id_tag);
          }
        });
      }
      return msg;
    },
    /**
     * replaceUserIdMicro
     * User tag with user name by user id for mention user
     */
    async replaceUserIdMicro(message, tagStrArr) {
      var user_contact_list = await this.getUserContactList;
      return utility.replaceUserIdMicro(message, tagStrArr, user_contact_list);
    },
    /**
     * open_attachment_dialog
     */
    open_attachment_dialog(e) {
      if(e.target.files.length > 0){
        let files = e.target.files;
        this.attachment_file_src = files;
        this.users = this.mention_users_for_attachment;
        this.attachmentFileDialog = true;
      }
      else{
        this.attachmentFileDialog = false;
      }
    },
    /**
     * openFileBrowser
     */
    openFileBrowser(allowedMimeType=null) {
      utility.openFileBrowser(this, allowedMimeType);
    },
    /**
     * attachment_file_src_obj
     */
    attachment_file_src_obj() {
      this.attachment_file_src = null;
    },
    /**
     * collect_attachment_files
     */
    collect_attachment_files(files) {
      //files = files.reverse();
      if (files && files.length > 0) {
        files.forEach((file) => {
          let text_msg = file.url;
          this.attachment_file = file.file;
          if (file.caption) {
            text_msg = text_msg + " " + file.caption;
          }
          
          if(file.mention_users && file.mention_users.length > 0){
            file.mention_users.forEach((mu)=>{
              this.users.push(mu);
            })
          }
          
          this.msg = text_msg;
          this.collect_msg();
        });
      }
    },
    /*
    * get_user_icon
    * */
    get_user_icon(participant){
      var user = {
        user_id : participant.participant_id,
        image : participant.participant_image,
        user_name: participant.participant_name
      }
      var user_icon = media_utility.get_user_icon(user, this.user_contact_list);
      return user_icon;
    },
  },//End of methods
  watch: {
    replyMsg: function () {
      this.$refs.send_msg.focus();
    },
    selectedGroup() {
      this.msg = "";
      this.get_group_participants_api();
    },
  },
  directives: {
    plaintext: async function (el, binding, vnode) {
      let msg = el.textContent;
      var tagStrArr = utility.getUserTags(msg);
      if (tagStrArr) {
        msg = await vnode.context.replaceUserIdMicro(msg, tagStrArr);
        el.innerHTML = msg;
      }
    },
  },
};
